import Config from '@/config/index';
export const withDevice = () => {
    const { innerHeight: height, innerWidth: width } = window;
    const devicePlatform = Config.isMobile ? 'mobile web' : 'desktop web';
    const screenDimensions = { height, width };
    return {
        'device platform': devicePlatform,
        device_platform: devicePlatform,
        'screen dimensions': screenDimensions,
        screen_dimensions: screenDimensions,
    };
};
